import React from 'react';
import PropTypes from 'prop-types';
import { SocialIcon } from 'react-social-icons/component';
import 'react-social-icons/bsky.app';
import 'react-social-icons/discord';
import 'react-social-icons/github';
import 'react-social-icons/email';
import 'react-social-icons/linkedin';

const socialProfiles = [
  'https://bsky.app/profile/farias.dev',
  'https://discord.com/users/272116884877344778',
  'https://www.linkedin.com/in/murilofarias/',
  'https://github.com/murilomentor',
  'mailto:murilomentor@gmail.com',
];

function SocialLinks({ title }) {
  return (
    <div className="App-social">
      {title && <h2>{title}</h2>}
      {socialProfiles.map((url, idx) => {
        const network = url.startsWith('mailto:') ? 'email' : undefined;
        return <SocialIcon key={idx} url={url} network={network} />;
      })}
    </div>
  );
}

SocialLinks.propTypes = {
  title: PropTypes.string,
};

export default SocialLinks;
